<template>
    <div class="modal fade show d-block" tabindex="-1" role="dialog" >
      <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('simple.delete') }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$close()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">

            <v-wait for="customer_type_delete">

                <loading slot="waiting"/>

                <b-alert variant="danger" show> {{ $t('simple.delete_confirm') }}</b-alert>

            </v-wait>

          </div>

          <div class="modal-footer">

            <b-button @click="$close(false)" variant="secondary">{{ $t('simple.cancel') }}</b-button>
            <div v-b-tooltip.hover.right="{
                 title:!user_permissions.includes('delete-customer-types')? $t('permission.permission_denied', { permission: 'delete-customer-types' }) : '',customClass: 'tooltip-dark' }"
                 style="display: inline-block">
              <b-button @click="customer_type_delete" variant="primary" :class="!user_permissions.includes('delete-customer-types') ? 'cursor-not-allowed' : ''"
                        :disabled="!user_permissions.includes('delete-customer-types')">{{ $t('simple.delete') }}</b-button>
            </div>
          </div>

        </div>
      </div>
    </div>
</template>
<script>

    import {mapGetters} from "vuex";

    export default {

        mounted: function () {
            // Component mounted
            console.log('Customer Type Remove Modal mounted');
        },

        destroyed() {
            // Component Destroyed
            console.log('Customer Type Remove Modal destroyed.');
        },

        data: function() {
             return  {
                customer_types_api: '/api/v1/settings/customer/types/',
             }
        },

        methods: {

            customer_type_delete: async function(){

                // Loading start
                this.$wait.start('customer_type_delete');

                await axios.delete(this.customer_types_api + this.id)

                .then((response) => {

                    // Loading stop
                    this.$wait.end('customer_type_delete');

                    // Show success
                    Vue.toasted.success(this.$t('simple.deleted_confirmed'));

                    // Close modal
                    this.$close(true);
                    //console.log(response);

                })
                .catch((error) => {
                  // Show error
                  if (error.response && error.response.status === 403) {
                    Vue.toasted.error(this.$t('permission.permission_denied',{ permission: 'delete-customer-types'}));
                  } else {
                    Vue.toasted.error(this.$t('simple.error_info'));
                  }
                    // Log to console
                    console.log(error);

                    // Loading stop
                    this.$wait.end('customer_type_delete');

                    // Close modal
                    this.$close(true);


                });

            },
        },
      computed: {
        // Map getters
        ...mapGetters({
          user_permissions: 'User/getUserPermissions'
        })
      },
    }
</script>